import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { CultureTextModel } from '../form';

export interface WeblinkFieldModel extends BaseFieldModel {
  defaultValue: CultureTextModel[] | string;
  target: string;
  placeholder: CultureTextModel[] | string;
  type: FieldType.WebLink;
}
export class WeblinkField extends BaseField implements WeblinkFieldModel {
  public defaultValue: CultureTextModel[] | string = '';
  public target = '_blank';
  public placeholder: CultureTextModel[] | string = '';
  public type: FieldType.WebLink = FieldType.WebLink;

  constructor(cultures: string[]) {
    super(FieldType.WebLink, cultures);

    this.placeholder = [];
    this.defaultValue = [];

    for (const culture of cultures) {
      this.placeholder.push({ culture, value: '' });
      this.defaultValue.push({ culture, value: '' });
    }
  }
}
